/** The most invisible characters one press can make. */
export const MAX_COUNT = 500;

export type CountNote = "" | "min" | "max" | "empty";

/**
 * What the number box should show for what was typed, so the box, the line under it and the copied text always agree (B-0153).
 * Letters are dropped; 0 becomes 1; anything above 500 becomes 500; an emptied box keeps the previous count (and says so).
 */
export function normalizeCount(raw: string, previous: number): { text: string; count: number; note: CountNote } {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return { text: "", count: previous, note: "empty" };
  const n = parseInt(digits, 10);
  if (n < 1) return { text: "1", count: 1, note: "min" };
  if (n > MAX_COUNT) return { text: String(MAX_COUNT), count: MAX_COUNT, note: "max" };
  return { text: String(n), count: n, note: "" };
}

export function countNoteText(note: CountNote, count: number): string {
  if (note === "min") return "The minimum is 1, so 1 will be used.";
  if (note === "max") return `The most you can generate is ${MAX_COUNT}, so ${MAX_COUNT} will be used.`;
  if (note === "empty") return `Type a number from 1 to ${MAX_COUNT}. Until then ${count} will be used.`;
  return "";
}
